import gql from "graphql-tag";

export const updateUser = gql`
  mutation updateUser(
    $input: UpdateUserInput!) {
    updateUser(input: $input) {
      user {
        id
        name
        email
      }
    }
  }
`;

export const updateUserOptions = {
  name: "updateUser",
};
